export const TOTEM_IDS = ["carved", "antler", "spiral"] as const;

export type TotemId = (typeof TOTEM_IDS)[number];

export const DEFAULT_TOTEM_ID: TotemId = "carved";

export function isTotemId(value: unknown): value is TotemId {
  return (
    typeof value === "string" &&
    (TOTEM_IDS as readonly string[]).includes(value)
  );
}
